// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { LogLevel } from "./ILogger";
import { TransferFormat } from "./ITransport";
import { Arg, getDataDetail, sendMessage } from "./Utils";
/** @private */

var ServerSentEventsTransport =
/** @class */
function () {
  function ServerSentEventsTransport(httpClient, accessTokenFactory, logger, logMessageContent, eventSourceConstructor) {
    this.httpClient = httpClient;
    this.accessTokenFactory = accessTokenFactory;
    this.logger = logger;
    this.logMessageContent = logMessageContent;
    this.eventSourceConstructor = eventSourceConstructor;
    this.onreceive = null;
    this.onclose = null;
  }

  ServerSentEventsTransport.prototype.connect = function (url, transferFormat) {
    return __awaiter(this, void 0, void 0, function () {
      var token;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            Arg.isRequired(url, "url");
            Arg.isRequired(transferFormat, "transferFormat");
            Arg.isIn(transferFormat, TransferFormat, "transferFormat");
            this.logger.log(LogLevel.Trace, "(SSE transport) Connecting."); // set url before accessTokenFactory because this.url is only for send and we set the auth header instead of the query string for send

            this.url = url;
            if (!this.accessTokenFactory) return [3
            /*break*/
            , 2];
            return [4
            /*yield*/
            , this.accessTokenFactory()];

          case 1:
            token = _a.sent();

            if (token) {
              url += (url.indexOf("?") < 0 ? "?" : "&") + ("access_token=" + encodeURIComponent(token));
            }

            _a.label = 2;

          case 2:
            return [2
            /*return*/
            , new Promise(function (resolve, reject) {
              var opened = false;

              if (transferFormat !== TransferFormat.Text) {
                reject(new Error("The Server-Sent Events transport only supports the 'Text' transfer format"));
                return;
              }

              var eventSource;

              if (typeof window !== "undefined") {
                eventSource = new _this.eventSourceConstructor(url, {
                  withCredentials: true
                });
              } else {
                // Non-browser passes cookies via the dictionary
                var cookies = _this.httpClient.getCookieString(url);

                eventSource = new _this.eventSourceConstructor(url, {
                  withCredentials: true,
                  headers: {
                    Cookie: cookies
                  }
                });
              }

              try {
                eventSource.onmessage = function (e) {
                  if (_this.onreceive) {
                    try {
                      _this.logger.log(LogLevel.Trace, "(SSE transport) data received. " + getDataDetail(e.data, _this.logMessageContent) + ".");

                      _this.onreceive(e.data);
                    } catch (error) {
                      _this.close(error);

                      return;
                    }
                  }
                };

                eventSource.onerror = function (e) {
                  var error = new Error(e.data || "Error occurred");

                  if (opened) {
                    _this.close(error);
                  } else {
                    reject(error);
                  }
                };

                eventSource.onopen = function () {
                  _this.logger.log(LogLevel.Information, "SSE connected to " + _this.url);

                  _this.eventSource = eventSource;
                  opened = true;
                  resolve();
                };
              } catch (e) {
                reject(e);
                return;
              }
            })];
        }
      });
    });
  };

  ServerSentEventsTransport.prototype.send = function (data) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        if (!this.eventSource) {
          return [2
          /*return*/
          , Promise.reject(new Error("Cannot send until the transport is connected"))];
        }

        return [2
        /*return*/
        , sendMessage(this.logger, "SSE", this.httpClient, this.url, this.accessTokenFactory, data, this.logMessageContent)];
      });
    });
  };

  ServerSentEventsTransport.prototype.stop = function () {
    this.close();
    return Promise.resolve();
  };

  ServerSentEventsTransport.prototype.close = function (e) {
    if (this.eventSource) {
      this.eventSource.close();
      this.eventSource = undefined;

      if (this.onclose) {
        this.onclose(e);
      }
    }
  };

  return ServerSentEventsTransport;
}();

export { ServerSentEventsTransport };